import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { createRoot } from 'react-dom/client'
import { loadLocales } from '@/locales'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'

dayjs.locale('zh-cn')

loadLocales().then(async () => {
  // router
  const { default: Routers } = await import(
    /* webpackMode: "eager" */
    '@/routers'
  )

  // 原型扩展
  // import(
  //   /* webpackMode: "eager" */
  // )

  // scss入口文件
  import(
    /* webpackMode: "eager" */
    '@/assets/style/index.scss'
  )

  const rootRender = () => {
    const root = createRoot(document.getElementById('root'))
    root.render(
      <Routers />
    )
  }
  rootRender()
})